var map = {
	"./en-US.json": [
		23516,
		[
			3963
		]
	],
	"./zh-CN.json": [
		65054,
		[
			6985
		]
	],
	"./zh-TW.json": [
		85034,
		[
			7229
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99780;
module.exports = webpackAsyncContext;